export default {"src":"/_next/static/media/kotlin_logo_609a713d60.3e54d70d.svg","height":160,"width":320,"blurWidth":0,"blurHeight":0};